function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.6837 18H5.72954C5.05063 18 4.5 17.6021 4.5 17.1115V2.88854C4.5 2.39792 5.05063 2 5.72954 2H14.6837C15.3627 2 15.9133 2.39792 15.9133 2.88854V17.1115C15.9147 17.6021 15.3641 18 14.6837 18Z",
  fill: "currentcolor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4783 5.25983H6.67386C6.37384 5.25983 6.13037 5.00911 6.13037 4.70017C6.13037 4.39122 6.37384 4.1405 6.67386 4.1405H10.4783C10.7783 4.1405 11.0218 4.39122 11.0218 4.70017C11.0218 5.00911 10.7783 5.25983 10.4783 5.25983Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7223 5.25934C13.4129 5.25934 13.1619 5.00863 13.1619 4.69968C13.1619 4.39073 13.4129 4.14001 13.7223 4.14001C14.0317 4.14001 14.2828 4.39073 14.2828 4.69968C14.2828 5.00863 14.0317 5.25934 13.7223 5.25934Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4783 15.8599H6.67386C6.37384 15.8599 6.13037 15.6092 6.13037 15.3003C6.13037 14.9913 6.37384 14.7406 6.67386 14.7406H10.4783C10.7783 14.7406 11.0218 14.9913 11.0218 15.3003C11.0218 15.6092 10.7783 15.8599 10.4783 15.8599Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7223 15.8594C13.4129 15.8594 13.1619 15.6087 13.1619 15.2998C13.1619 14.9908 13.4129 14.7401 13.7223 14.7401C14.0317 14.7401 14.2828 14.9908 14.2828 15.2998C14.2828 15.6087 14.0317 15.8594 13.7223 15.8594Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4786 10.5593H6.67417C6.37415 10.5593 6.13068 10.3086 6.13068 9.99967C6.13068 9.69072 6.37415 9.44 6.67417 9.44H10.4786C10.7786 9.44 11.0221 9.69072 11.0221 9.99967C11.0221 10.3086 10.7786 10.5593 10.4786 10.5593Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7223 10.5593C13.4129 10.5593 13.1619 10.3086 13.1619 9.99967C13.1619 9.69072 13.4129 9.44 13.7223 9.44C14.0317 9.44 14.2828 9.69072 14.2828 9.99967C14.2828 10.3086 14.0317 10.5593 13.7223 10.5593Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 6.99329H15.9133V7.80852H4.5V6.99329Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 12.1904H15.9133V13.0057H4.5V12.1904Z",
  fill: "white"
});

const SvgDatabase = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDatabase, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/database.670ad20d.svg";
export { ForwardRef as ReactComponent };